import React from "react";
import {
  withStyles,
  Theme,
  createStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { Grid, Container } from "@material-ui/core";
import intl from "react-intl-universal";

import Typography from "../components/Typography";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      overflow: "hidden",
      backgroundColor: theme.palette.secondary.light,
    },
    container: {
      marginTop: theme.spacing(15),
      marginBottom: theme.spacing(30),
      display: "flex",
      position: "relative",
    },
    item: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: theme.spacing(0, 5),
    },
    image: {
      height: 55,
    },
    title: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
    },
    curvyLines: {
      pointerEvents: "none",
      position: "absolute",
      top: -180,
    },
  });

function ProductValues(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <img
          src="/productCurvyLines.png"
          className={classes.curvyLines}
          alt="curvy lines"
        />
        <Grid container spacing={5}>
          <Grid item xs={12} md={6}>
            <div className={classes.item}>
              <img className={classes.image} src="/productValues1.svg" alt="" />
              <Typography variant="h6" className={classes.title}>
                {intl.get("LANDING_VALUE_EASY_TO_USE_TITLE")}
              </Typography>
              <Typography variant="h5">
                {intl.get("LANDING_VALUE_EASY_TO_USE_DESC")}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <div className={classes.item}>
              <img className={classes.image} src="/productValues2.svg" alt="" />
              <Typography variant="h6" className={classes.title}>
                {intl.get("LANDING_VALUE_COMPREHENSIVE_DATA_TITLE")}
              </Typography>
              <Typography variant="h5">
                {intl.get("LANDING_VALUE_COMPREHENSIVE_DATA_DESC")}
              </Typography>
            </div>
          </Grid>
        </Grid>
      </Container>
    </section>
  );
}

export default withStyles(styles)(ProductValues);
